import React from 'react';
import { FaStar } from 'react-icons/fa';
import { useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../SidebarInAdminPanel/Sidebar';

const reviews = [
  {
    name: "Masood Khan",
    email: "masood@example.com",
    title: "Verified Buyer",
    rating: 4,
    description: "Great product quality and service. Very satisfied with the purchase.",
    comment: "Thank you!",
    date: "Nov 13, 2022",
    time: "3:45 PM",
    helpfulYes: 2,
    helpfulNo: 0,
    recommended: true,
    imageUrl: "/Images/shoespost.jpeg",
  },
  {
    name: "Sofia Amir",
    email: "sofia@example.com",
    title: "Verified Buyer",
    rating: 5,
    description: "Excellent experience. Fast delivery and product as described!",
    comment: "Thank you!",
    date: "Nov 13, 2022",
    time: "4:20 PM",
    helpfulYes: 5,
    helpfulNo: 0,
    recommended: true,
    imageUrl: "/Images/shoespost.jpeg",
  },
  {
    name: "Irfan Khan",
    email: "irfan@example.com",
    title: "Verified Buyer",
    rating: 5,
    description: "Excellent experience. Fast delivery and product as described!",
    comment: "Thank you!",
    date: "Nov 13, 2022",
    time: "4:20 PM",
    helpfulYes: 5,
    helpfulNo: 0,
    recommended: true,
    imageUrl: "/Images/shoespost.jpeg",
  },
];

const AllUserReviewsPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <div className="flex bg-gradient-to-r from-[#0AD1C8] to-[#073235] min-h-screen">
      <Sidebar />
      <div className="flex-1 p-8">
      <button
  onClick={() => navigate(`/user-detail/${id}`)}
  className="text-white mb-4 text-lg font-semibold transform transition-transform duration-300 hover:scale-105 hover:text-yellow-300"
>
  ← Back to User Details
</button>

<h2 className="text-3xl font-bold text-white mb-4 -mt-2">User Reviews</h2>


        <div className="grid md:grid-cols-2 gap-6">
          {reviews.map((review, index) => (
            <div
              key={index}
        className={`bg-white rounded-2xl shadow-md transition-all duration-300 p-6 flex flex-col md:flex-row gap-5 border-4 transform hover:scale-105 ${
  index % 3 === 0
    ? 'border-[#0AD1C8] hover:border-[#0bbdb7]'
    : index % 3 === 1
    ? 'border-[#12BFA1] hover:border-[#0aa48b]'
    : 'border-[#4BD4A0] hover:border-[#37b488]'
}`}

            >
              {/* User image */}
              <img
                src={review.imageUrl}
                alt="User"
                className="w-24 h-24 rounded-full object-cover ring-4 ring-[#CBDCEB] shadow"
              />

              {/* Review content */}
              <div className="flex-1 space-y-2 text-gray-800">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="text-xl font-bold">{review.name}</p>
                    <p className="text-sm text-gray-600">{review.title}</p>
                    <p className="text-sm"><span className="font-semibold">Email:</span> {review.email}</p>
                  </div>
                  <div className="flex items-center gap-1 text-yellow-400 text-lg">
                    {Array.from({ length: review.rating }, (_, i) => (
                      <FaStar key={i} />
                    ))}
                  </div>
                </div>

                <div>
                  <p className="text-md"><span className="font-semibold">Description:</span> {review.description}</p>
                  <p className="text-sm italic text-gray-600">"{review.comment}"</p>
                </div>

                <div className="text-sm text-gray-600 flex flex-col sm:flex-row sm:justify-between sm:items-center">
                  <p>Helpful? Yes ({review.helpfulYes}) | No ({review.helpfulNo})</p>
                  <p>{review.time} | {review.date}</p>
                </div>

                {review.recommended && (
                  <span className="inline-block mt-2 bg-green-100 text-green-700 text-sm font-medium px-3 py-1 rounded-full shadow-sm">
                    ✔ Recommended
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AllUserReviewsPage;
